import { S3, BUCKETS } from "./utils/s3-utils";
import { getDateDiffInMinutes } from "./utils/general-utils";
import { API_EndPoints, ExecuteAPIGet } from "./utils/onit-server-utils";

let cacheDates = {};
let cache = {};

export async function GetInstanceList() {
    return await ExecuteAPIGet<string[]>(API_EndPoints.GetInstanceList)
}

export async function loadRepositoryURLs() {
    const _data = await GetInstanceList();
    localStorage.setItem("graphDBRepos", JSON.stringify(_data));

}
export async function backupRepository(url: string) {
    const s = url.split("/")
    const repoName = s[s.length - 1];
    const u = `${url}/statements?infer=false`
    const response = await fetch(u, {
        mode: "cors",
        method: 'GET',
        headers: {
            Accept: "application/x-trig"
            // Accept: "application/rdf+xml"
        }
    })
    response.text().then((text) => {
        const s3 = new S3();
        s3.UploadFile(BUCKETS.PERMANENT_BACKUPS(), `m_${(new Date()).YYMMDDHHMM2()}_${repoName}.trig`, text);
    });
}

export function searchParams(data: any) {
    return Object.keys(data).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');
}

export function storeCacheData<T>(key: string, data: T, entity: string) {
    cache[entity + "-" + key] = data;
    cacheDates[entity + "-" + key] = new Date(Date.now());
}

export function deleteCacheData<T>(entity: string) {
    /*Object.keys(cache).map((key) => {
        if (key.length && key.indexOf(entity + "-") == 0) {
            cache[key] = undefined;
            cacheDates[key] = undefined;
        }
    })*/
}

export function getCacheData<T>(key: string, entity: string) {
    try {
        const data = cache[entity + "-" + key] as T;
        const cacheDate = new Date(cacheDates[entity + "-" + key]);
        const diff = getDateDiffInMinutes(new Date(Date.now()), cacheDate);
        if (diff > 5) {
            return;
        } else
            return data;
    } catch (error) {
        return;
    }
}
export function clearCacheData() {
    cacheDates = {};
    cache = {};
}

export function getString(str: any): string {
    return str && typeof (str) == "string" ? str : str && str.value && str.value != "undefined" ? str.value : "" ;
}

export function genRandomvalue(min, max, decimalPlaces) {
    var rand = Math.random() * (max - min) + min;
    var power = Math.pow(10, decimalPlaces);
    return Math.floor(rand * power) / power;
}





// WEBPACK FOOTER //
// ./src/server/graphDB-utils.ts